export const bg = {
  regular: 'darkBlue.18',
  disabled: 'sandstone.55',
} as const

export const borderRadius = 1

export const boxShadow = 2
